import React, { useMemo } from "react";
import { SelectInput, useTranslate } from "react-admin";

const CHOICES = ["completed", "incomplete", "not_started"];

const ProgressInput = ({ ...props }) => {
  const translate = useTranslate();
  const choices = useMemo(
    () =>
      CHOICES.map((id) => ({
        id,
        name: translate(`resources.research-project-evals.progress.${id}`),
      })),
    [translate]
  );
  return <SelectInput {...props} choices={choices} />;
};
export default ProgressInput;
